import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShoppingCartIcon } from 'lucide-react';
export function ProductHero() {
  return <section className="w-full bg-sage-50 py-12 lg:py-24 px-6 md:px-12 flex justify-center" data-id="element-91">
      <div className="max-w-6xl w-full flex flex-col lg:flex-row gap-12 lg:gap-20 items-center lg:items-start" data-id="element-92">
        {/* Image Side */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="w-full lg:w-1/2" data-id="element-93">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-sage-200/50" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/4PDk4V9Rz5r8WMdsYHUhZe/cover_from.png" alt="14 Días de Liberación E-book Cover" className="w-full h-auto object-cover aspect-[4/5] lg:aspect-auto lg:h-[600px]" data-id="element-95" />
          </div>
        </motion.div>

        {/* Product Info Side */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full lg:w-1/2 flex flex-col" data-id="element-96">
          <span className="inline-block text-sage-600 font-bold tracking-widest text-xs uppercase mb-3" data-id="element-97">
            E-BOOK PDF · DESCARGA INMEDIATA
          </span>

          <h1 className="text-4xl md:text-5xl font-playfair font-medium text-bark-900 leading-tight mb-4" data-id="element-98">
            14 Días de Liberación
          </h1>

          <p className="text-lg md:text-xl font-lato italic text-bark-700 mb-8" data-id="element-99">
            Plan médico–espiritual de 14 días para energía estable, menos
            antojos y mejor sueño.
          </p>

          {/* Price Block */}
          <div className="flex items-end gap-4 mb-8" data-id="element-100">
            <div className="flex flex-col" data-id="element-101">
              <span className="text-bark-700/50 line-through text-lg font-lato" data-id="element-102">
                $19.00
              </span>
              <span className="text-4xl font-bold text-bark-900 font-lato" data-id="element-103">
                $6.36{' '}
                <span className="text-xl text-bark-700 font-normal" data-id="element-104">USD</span>
              </span>
            </div>
            <div className="mb-2" data-id="element-105">
              <span className="bg-sage-100 text-sage-600 text-sm font-bold px-3 py-1 rounded-full" data-id="element-106">
                Ahorre 67%
              </span>
            </div>
          </div>

          <div className="w-full h-px bg-sage-200 mb-8" data-id="element-107"></div>

          {/* Quick Bullets */}
          <ul className="space-y-4 mb-10" data-id="element-108">
            {['Descarga inmediata (PDF)', 'Plan de 14 días (paso a paso)', 'Plato Fácil + hábitos + movimiento + sueño', 'Repetible (Edición Evergreen)'].map((bullet, idx) => <li key={idx} className="flex items-start" data-id="element-109">
                <CheckIcon className="w-5 h-5 text-sage-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-110" />
                <span className="text-bark-800 font-lato text-lg" data-id="element-111">
                  {bullet}
                </span>
              </li>)}
          </ul>

          {/* CTA Area */}
          <div className="flex flex-col w-full" data-id="element-112">
            <a href="#comprar" className="w-full bg-sage-600 hover:bg-sage-500 text-white py-4 px-8 rounded-md text-lg font-bold font-lato flex items-center justify-center gap-3 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 mb-4 no-underline" aria-label="Comprar y descargar ahora" data-id="element-113">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-114" />
              Comprar y descargar ahora
            </a>

            <p className="text-sm text-bark-700 italic text-center mb-2" data-id="element-115">
              Empiece cuando quiera: Día 1 = el día que usted comienza.
            </p>

            <p className="text-xs text-bark-700/70 text-center" data-id="element-116">
              Descarga inmediata (PDF) • Uso personal • Edición Evergreen (puede
              repetirse)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}